module.exports = __webpack_public_path__ + "static/media/phone-frame-min.5eee8aaf.webp";